<template>
	<v-dialog v-model="dialog" max-width="600px">
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white"
					>編集：{{ orderComponent.component.name }}
				</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2">
				<p class="my-2">品番：{{ orderComponent.component.part_number }}</p>
				<v-form ref="form" lazy-validation>
					<v-row class="d-flex flex-wrap justify-center" no-gutters>
						<v-text-field
							type="number"
							v-model="orderComponent.quantity"
							class="mt-2 mx-1"
							label="数量"
							outlined
							dense
						/>
						<v-text-field
							type="number"
							v-model="orderComponent.unit_price"
							class="mt-2 mx-1"
							label="単価"
							outlined
							dense
						/>
					</v-row>
					<v-row class="d-flex flex-wrap justify-center" no-gutters>
						<v-textarea
							v-model="orderComponent.remarks"
							class="mt-2 mx-1"
							label="備考"
							outlined
							dense
						/>
					</v-row>
					<div class="pa-2">
						<div
							v-for="file in orderComponent.return_all_attached_file_infos"
							:key="file.id"
							class="mx-2"
						>
							<a v-if="!file.destroy_flag" :href="file.url" target="_blank">{{ file.name }}</a
							><v-icon v-if="!file.destroy_flag" @click="openFileDeleteConfirm(file.id, file.name)"
								>mdi-delete</v-icon
							>
						</div>
					</div>

					<DragUpload @fileShare="fileShare" v-if="orderComponent.component.wildcard" />

					<v-row class="d-flex flex-wrap justify-center" no-gutters>
						<v-btn class="ma-2 pa-2 mt-4" color="primary" @click="updateOrderComponent()"
							>更新</v-btn
						>
						<v-btn class="ma-2 pa-2 mt-4" color="primary" @click="openOrderComponentDeleteConfirm()"
							>削除</v-btn
						>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-row no-gutters> </v-row>
			</v-card-actions>
		</v-card>
		<DeleteFileConfirm ref="deleteFile" @yes="deleteFile" />
		<DeleteOrderComponentConfirm ref="deleteOrderComponent" @yes="deleteOrderComponent" />
	</v-dialog>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import FunctionTitle from "../../shared/FunctionTitle.vue"
import CommonFlame from "../../shared/CommonFlame.vue"
import DragUpload from "../../shared/DragUpload.vue"
import DeleteFileConfirm from "./DeleteConfirm.vue"
import DeleteOrderComponentConfirm from "./DeleteConfirm.vue"

export default {
	components: { DragUpload, DeleteFileConfirm, DeleteOrderComponentConfirm },

	props: {
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			dialog: false,
			orderComponent: {
				component: {
					name: "",
					wildcard: false,
				},
				remarks: "",
				quantity: "",
				id: "",
				unit_price: "",
				return_all_attached_file_infos: [],
			},
			uploadFiles: [],
		}
	},
	methods: {
		openFileDeleteConfirm(id, filename) {
			let title = "添付ファイルの削除"
			let message =
				"「" + filename + "」を削除します。削除するとデータの復旧はできません。よろしいですか？"
			this.$refs.deleteFile.openDialog(title, message, id)
		},
		fileShare(files) {
			this.uploadFiles = files
		},
		openDialog(orderComponent) {
			this.dialog = true
			this.orderComponent = orderComponent
		},
		deleteFile(id) {
			let url = "/erp/v1/parts_list/files/" + id + ".json"
			const headers = authenticate.setHeader()
			axios
				.delete(url, { headers })
				.then((res) => {
					this.$store.commit("setFlash", {
						type: "notice",
						text: "削除しました",
					})
					this.orderComponent.return_all_attached_file_infos =
						res.data.return_all_attached_file_infos
					this.$emit("reloadFiles", res.data.return_all_attached_file_infos)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		updateOrderComponent() {
			const headers = authenticate.setHeader()
			var formData = new FormData()
			formData.set("quantity", this.orderComponent.quantity)
			formData.set("remarks", this.orderComponent.remarks)
			axios
				.put("/erp/v1/parts_list/order_components/" + this.orderComponent.id, formData, { headers })
				.then((res) => {
					this.$store.commit("setFlash", {
						type: "notice",
						text: "更新しました。",
					})
					this.$emit("updateOrderComponent", res.data.order_component)
					this.dialog = false
					this.uploadFiles.forEach((file) => {
						this.fileUpload(file, this.orderComponent.id)
					})
					this.orderComponent = {
						quantity: "",
						id: "",
						remarks: "",
						unit_price: "",
						component: {
							wildcard: false,
						},
					}
					this.uploadFiles = []
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openOrderComponentDeleteConfirm() {
			const headers = authenticate.setHeader()
			axios
				.get(
					"/erp/v1/parts_list/receiving_shippings_exist_check/" + this.orderComponent.id + ".json",
					{ headers }
				)
				.then((res) => {
					if (res.data.result) {
						console.log(res.data.result)
						this.$store.dispatch("setFlash", {
							text: "すでに部品の入出庫が割り当てられています。割当データを削除してください",
							type: "alert",
						})
					} else {
						let title = "製品から部品データを削除"
						let message =
							"「" +
							this.orderComponent.product.name +
							"」を削除します。削除するとデータの復旧はできません。また添付されているデータも削除されます。よろしいですか？"
						this.$refs.deleteOrderComponent.openDialog(title, message, this.orderComponent.id)
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		deleteOrderComponent() {
			const headers = authenticate.setHeader()
			axios
				.delete("/erp/v1/parts_list/order_components/" + this.orderComponent.id + ".json", {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "削除しました",
						type: "notice",
					})
					this.closeDialog()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		closeDialog() {
			this.dialog = false
			this.orderComponent = {
				component: {
					name: "",
					wildcard: false,
				},
				remarks: "",
				quantity: "",
				id: "",
				unit_price: "",
				return_all_attached_file_infos: [],
			}
			this.uploadFiles = []
			this.$emit("reloadIndex")
		},
		fileUpload(file, order_component_id) {
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			formData.append("order_component_id", order_component_id)
			formData.append("file", file)
			axios
				.post("/erp/v1/parts_list/files", formData, { headers })
				.then((res) => {
					if (!res.data.no_error) {
						this.$store.dispatch("setFlash", {
							text: res.data.miss_file + "の作成に失敗しました",
							type: "alert",
						})
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {},
}
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
	margin-top: 0;
}
</style>
